import reducer from './reducer'

import * as masterTradesOperations from './operations'
import * as masterTradesSelectors from './selectors'

export { masterTradesOperations, masterTradesSelectors }

export default reducer
